import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HomePage} from '../pages/home/home.page';
import {CharacterService} from '../services/character.service';
import {DragulaModule} from 'ng2-dragula';
import {FormsModule} from '@angular/forms';

@NgModule({
  declarations: [
    AppComponent,
    HomePage,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    DragulaModule.forRoot(),
    AppRoutingModule
  ],
  providers: [
    CharacterService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
